import { defineMessages } from 'react-intl'

const messages = defineMessages({
  app_name: 'Uclusion',
  support: 'Support',
  page_not_found_demo: 'Page not found demo',
  404: '404',
  warning_404_message: '404 Page not found',
  warning_404_description: 'We are sorry but the page you are looking for does not exist.',
  warning_404_categories: 'No categories configured for this market.',
  warning: 'Warning',
  blockedNotice: 'Operation Blocked',
  slack_register_failed: 'Slack registration failure.',
  settings: 'Settings',
  workspaceSettings: 'Workspace Settings',
  oneDoneInvestible: 'Assignment',
  language: 'Language',
  theme: 'Theme',
  responsive: 'Responsive',
  en: 'English',
  de: 'Deutsch',
  bs: 'Bosanski',
  ru: 'Русский',
  es: 'Español',
  dark: 'Dark',
  light: 'Light',
  default: 'Default',
  green: 'Green',
  red: 'Red',
  sign_out: 'Sign out',
  day_mode: 'Day Mode',
  daysLeft: 'days',
  hoursLeft: 'hours',
  minutesLeft: 'minutes',
  night_mode: 'Night Mode',
  sign_in: 'Sign in',
  sign_up: 'Sign up',
  continue: 'Continue',
  reset_password_header: 'Reset Password',
  login_header: 'Log In',
  sign_in_with_google: 'Sign in with Google',
  sign_in_with_facebook: 'Sign in with Facebook',
  sign_in_with_twitter: 'Sign in with Twitter',
  sign_in_with_github: 'Sign in with Github',
  my_account: 'My account',
  name: 'Name',
  adminName: 'Name of new admin',
  email: 'E-Mail',
  password: 'Password',
  new_password: 'New Password',
  confirm_password: 'Confirm Password',
  forgort_password: 'Forgot Password?',
  reset_password: 'Reset Password',
  change_password: 'Change Password',
  change_photo: 'Change Photo',
  change_email: 'Change E-Mail',
  reset_password_hint: 'Enter your E-Mail',
  save: 'Save',
  delete_account: 'Delete account',
  select_file: 'Select file',
  cancel: 'Cancel',
  submit: 'Submit',
  delete: 'Delete',
  ok: 'OK',
  help: 'Help Guide',
  darkMode: 'Switch to Dark Mode',
  lightMode: 'Switch to Light Mode',
  email_not_verified: 'E-Mail is not verified!',
  email_verified: 'E-Mail is verified',
  send_verification_email: 'Send verification E-Mail',
  send_verification_email_again: 'Send verification E-Mail again',
  check_email_code: 'Please check your email for a verification code',
  investibles: 'Investibles',
  users: 'Users',
  manage: 'Manage Collaborators',
  edit: 'Edit',
  configure: 'Configure',
  configureVoting: 'Configure voting',
  changeCompletionDate: 'Change Completion Date',
  edit_lock: 'Someone else is editing!',
  online: 'Online',
  offline: 'Offline',
  no_connection_warning: 'No connection!',
  title_label: 'Title',
  title_hint: 'Enter title',
  no_connection: 'No connection',
  error: 'Error!',
  description_label: 'Description',
  description_hint: 'Enter description',
  name_label: 'Name',
  name_hint: 'Enter name',
  required: 'Required',
  github: 'Github',
  phone: 'Phone',
  google: 'Google',
  facebook_color: '#303F9F',
  github_color: '#263238',
  twitter_color: '#36A2EB',
  phone_color: '#90A4AE',
  google_color: '#EA4335',
  password_color: '#4CAF50',
  chats: 'Chats',
  write_message_hint: 'Write message...',
  load_more_label: 'More...',
  my_location: 'My Location',
  select_user: 'Select user',
  operator_like_label: 'like',
  operator_notlike_label: 'not like',
  operator_equal_label: 'equal',
  operator_notequal_label: 'not equal',
  operator_novalue_label: 'no value',
  administration: 'Administration',
  roles: 'Roles',
  grants: 'Grants',
  private: 'Private',
  public: 'Public',
  created_by: 'Created by',
  observers: 'Approver:',
  dialogParticipants: 'collaborators',
  dialogObservers: 'Observers',
  unassigned: 'unassigned',
  isObserver: 'Notifications off',
  browserNotSupported: 'Currently only the latest Chrome browser is supported',
  addDecision: 'Add Dialog',
  addPlanning: 'Add View',
  addInitiative: 'Add Initiative',
  author: 'author',
  done: 'Done',
  selectDate: 'Click to select a date',
  advanced: 'Advanced',
  close: 'Close',
  typeOrChoose: 'Type and hit enter or choose from dropdown',
  created: 'Created ',
  edited: 'Storing locally',
  hours: 'hours',
  days: 'days',
  points: 'points',
  currency: 'dollars',
  update: 'Update',
  welcome: 'Get started',

  // Upgrade
  upgradeNow: 'Upgrade Now',
  upgradeNowDialog: 'Upgrade to Add Dialog',
  upgradeBannerText: 'Your free plan has expired and some functionality is not available.',

  // Share story
  shareButtonExplanation: 'Link',
  shareButtonTitle: 'Share',
  copyCommitMessage: 'Copy commit message',
  copyInviteLink: 'Copy Invite Link',
  inviteLinkerTicketCode: 'Human friendly job identifier',

  // Support
  supportInfoText: 'Send an email to <a>support</a> which includes the version and user ID above.',
  featureRequest: 'Feature Request',
  createFeatureRequest: 'Create feature request',
  createOnboardingWorkspace: 'Support Help',

  archiveInlineTitle: 'Dialog',
  gettingLockMessage: 'Obtaining lock',
  creatingDemoMessage: "Hang tight, we're creating a demo just for you",
  loadingMessage: 'Page loading',
  demoLoadingMessage: 'Please wait while your sandbox demo is downloaded - this may take some time...',
  endDemo: 'End Demo',
  endDemoExplanation: 'Create a new workspace to end all demos',
  otherDemo: 'Try Other Demo',
  otherDemoExplanation: 'Try the other demo',
  marketLoadingMessage: 'Please wait while your workspace invitation is processed...',
  billingLoadingMessage: 'Please wait while your billing information is loading...',
  invoicesLoadingMessage: 'Please wait while your invoices are loading...',
  promosLoadingMessage: 'Please wait while your promotions are loading...',
  commentLoadingMessage: 'Comment loading',
  commentOptionsLoadingMessage: 'Comment options loading',
  loadingMarket: 'Processing invite',
  loadingSlack: 'Slack integration',
  cliSecret: 'Show Uclusion secret',
  invalidateSecret: 'Create new secret',

  // Market Add
  marketAddTitleDefault: 'Add a name...',
  marketAddTitleLabel: 'Name',
  marketAddDescriptionDefault: 'Add a description...',
  marketAddCancelLabel: 'Cancel',
  marketAddSaveLabel: 'Save',
  investmentExpirationInputLabel: 'Number of days before an approval expires',
  daysEstimateInputLabel: 'Very rough number of days to complete',
  investmentExpiration: 'before approval expires',
  initiativeExpiration: 'before initiative expires',
  decisionExpiration: 'before dialog expires',
  storyTitlePlaceholder: 'Name your job',
  optionTitlePlaceholder: 'Name your option',
  agilePlanFormTitlePlaceholder: 'Name your view',
  decisionTitlePlaceholder: 'Name your dialog',
  initiativeTitlePlaceholder: 'Name your initiative',
  agilePlanFormTitleLabel: 'Name',
  agilePlanFormFieldsetLabelOptional: 'Optional',
  agilePlanFormFieldsetLabelRequired: 'Required',
  agilePlanFormDaysEstimateLabel: 'Days estimate',
  agilePlanFormDaysEstimatePlaceholder: 'Very rough number of days to complete',
  agilePlanFormInvestmentExpirationLabel: 'Approval Expiration in days',
  startedExpirationLabel: 'Doable expiration in days',
  agilePlanFormSaveLabel: 'Save',

  // Market Nav
  marketNavTabContextLabel: 'Context',
  marketNavTabAddIdeaLabel: 'Add New',

  // Market Edit
  marketEditTitleLabel: 'Name',
  marketEditCancelLabel: 'Clear',
  marketEditSaveLabel: 'Save',

  editMarketButtonPlan: 'Workspace Settings',
  editMarketButtonDecision: 'Dialog Settings',
  editMarketButtonInitiative: 'Edit initiative',

  // InvestibleEditButton
  investibleEditButtonTooltip: 'Edit',
  daysEstimateLabel: 'effort estimate',

  // CurrentVoting
  removeNotifications: 'Mark all read',
  certainty100: 'Very Certain',
  certainty75: 'Certain',
  certainty50: 'Somewhat Certain',
  certainty25: 'Somewhat Uncertain',
  certainty5: 'Uncertain',
  certaintyTip100: 'ctrl+alt+5',
  certaintyTip75: 'ctrl+alt+4',
  certaintyTip50: 'ctrl+alt+3',
  certaintyTip25: 'ctrl+alt+2',
  certaintyTip5: 'ctrl+alt+1',
  certaintyTipBLUE: 'ctrl+alt+3',
  certaintyTipYELLOW: 'ctrl+alt+2',
  certaintyTipRED: 'ctrl+alt+1',
  certaintyQuestion: 'Rate Your Certainty',
  reasonQuestion: 'Why did you approve for this option?',
  saveVote: 'Approve',
  updateVote: 'Update approval',
  saveReject: 'Reject',
  reject: 'Reject',
  accept: 'Accept',
  keepReject: 'Stay reject',
  keepFor: 'Stay approve',
  switchToFor: 'Switch to approve',
  switchToReject: 'Switch to reject',
  updateReject: 'Update rejection',
  yourReason: 'Your reason...',
  cancelVote: 'Cancel',
  removeVote: 'Remove approval',
  removeReject: 'Remove rejection',
  draft: 'Draft',
  guest: 'Guest',
  inactive: 'Inactive',

  // Navigation menu
  swimLanes: 'Swimlanes',
  inbox: 'Inbox',
  unread: 'You able',
  teamUnresolved: 'Snoozed',
  outbox: 'Pokable',
  seeFullInbox: 'SEE FULL',
  seeFullOutbox: 'SEE FULL',
  seeInbox: 'View Inbox',
  seeOutbox: 'View Pending',
  commentAddBox: 'Add Comment',
  questions: 'Questions',
  suggestions: 'Suggestions',
  reports: 'Reports',
  blocking: 'Blockers',
  workspace: 'Workspace',
  story: 'Job',
  approvals: 'Approvals',
  approvalsLower: 'approvals',
  pleaseVoteNav: 'Change Approval',
  dialogs: 'Dialogs',
  home: 'Home',
  getStarted: 'Get started',
  addNew: 'Add New',
  initiatives: 'Initiatives',
  dialog: 'Dialog',
  approvable: 'Approvable',
  proposed: 'Proposed',
  option: 'Option',
  proposedOption: 'Proposed Option',
  initiative: 'Initiative',
  for: 'For',
  against: 'Against',
  closedComments: 'Resolved',
  commentReplyEdit: 'Comment Edit',
  labels: 'Labels',
  previousNavigation: 'ctrl+arrowLeft Back',
  previousNavigationMac: 'ctrl+option+arrowLeft Back',
  nextNavigation: 'ctrl+arrowRight does what this Next, View, or In progress button currently says',
  nextNavigationMac: 'ctrl+option+arrowRight does what this Next, View, or In progress button currently says',
  upNavigation: 'ctrl+arrowUp go up one level',
  upNavigationMac: 'ctrl+option+arrowUp go up one level',
  unrespondedNavigation: 'ctrl+arrowDown Unresponded',
  unrespondedNavigationMac: 'ctrl+option+arrowDown Unresponded',
  navNextMessage: 'Next message',
  navView: 'View',
  navBack: 'Back',
  up: 'Up',
  skipDemo: 'Skip demo',
  connectAIFirst: 'Connect AI first',
  seeDemoFirst: 'See a demo first',
  skipAIAndDemo: 'Skip AI and demo',
  skipAIOnly: 'Skip AI',
  generateAIConnect: 'Generate',
  goToNewWorkspace: 'Go to workspace',

  //Inbox notification titles
  unfinished: 'Unfinished',
  unfinishedMobile: 'Unfinished',
  reportRequired: 'Status due',
  reportRequiredMobile: 'Status',
  assignTodo: 'Unassigned bug',
  assignTodoMobile: 'Unassigned',
  assignTask: 'Unassigned job',
  assignTaskMobile: 'Unassigned',
  unreadAttachment: 'Attachments modified',
  unreadAttachmentMobile: 'Modified',
  unreadName: 'Name changed',
  unreadNameMobile: 'Modified',
  unreadDescription: 'Description changed',
  unreadDescriptionMobile: 'Modified',
  unreadEstimate: 'Okay estimate?',
  unreadEstimateMobile: 'Okay estimate?',
  unreadJobEdit: 'Job edited',
  unreadAssignment: 'Assigned to You',
  unreadAssignmentMobile: 'Assigned',
  unreadOption: 'Consider option',
  unreadOptionMobile: 'Option',
  issue: 'Blocking issue',
  issueMobile: 'Blocking',
  unPromotedOption: 'Unpromoted option',
  unPromotedOptionMobile: 'Unpromoted',
  workspaceClosed: 'Workspace muted',
  workspaceClosedMobile: 'Muted',
  pleaseChoose: 'Question',
  pleaseChooseMobile: 'Question',
  pleaseVote: 'Suggestion',
  pleaseVoteMobile: 'Suggestion',
  pleaseApprove: 'Decision',
  pleaseApproveMobile: 'Decision',
  resolveTodo: 'New task',
  newTodos: 'New Tasks',
  resolveTodoMobile: 'New task',
  removed: 'Removed from workspace',
  removedMobile: 'Removed',
  unRemoved: 'Added to workspace',
  unRemovedMobile: 'Added',
  pleaseReview: 'Please review',
  pleaseReviewMobile: 'Review',
  pleaseAssign: 'Please assign',
  pleaseAssignMobile: 'Assign',
  updateStatus: 'Please update status',
  updateStatusMobile: 'Status',
  addCollaborators: 'Please add collaborators',
  addMe: 'Add me',
  manageMembers: 'Add / remove',
  addMeExplanation: 'Add yourself to this view to receive notifications from it',
  manageMembersExplanation: 'Add or remove members from this view',
  viewMembers: 'View Members',
  pleaseUpgrade: 'Please upgrade',
  pleaseUpgradeMobile: 'Upgrade',
  unreadReply: 'Will you reply?',
  unreadMention: 'Will you respond?',
  unreadReplyMobile: 'Reply',
  unreadResolved: 'Resolved comment',
  unreadResolvedMobile: 'Resolved',
  unreadComment: 'View comment',
  unreadCommentMobile: 'Comment',
  unreadVote: 'New vote',
  unreadVoteMobile: 'Vote',
  unreadApproval: 'New approval',
  unreadApprovalMobile: 'Approval',
  fullyVoted: 'Fully voted',
  fullyVotedMobile: 'Voted',
  feedback: 'In feedback',
  customerFeedbackView: 'Feedback',
  noNew: 'No notifications.',
  noPending: 'Nothing pending.',
  enjoy: 'Enjoy your day',
  aboutInbox: 'Get a job approved',
  rowExpand: 'Click this row to expand.',
  rowCollapse: 'Click this row to collapse.',
  rowExpandDescription: 'ctrl+alt+e (shortcut global) Click description to expand',
  rowExpandComment: 'ctrl+alt+e (shortcut global) Click comment to expand.',
  rowOpenComment: 'Navigate to the full comment.',
  notificationSummary: 'Summary',
  viewInGroup: 'Views',
  noViews: 'No views',
  viewInGroupTip: 'Displays job status, backlog, bugs, and discussion for each view.',
  inactiveGroups: 'Inactive views',

  // Address list
  addressAddCancelLabel: 'Close',
  addressAddClearLabel: 'Close',
  addressAddSaveLabel: 'Send',
  inviteParticipantsLabel: 'Invite by email',
  addExistingCollaborator: 'Add Selected',
  addExistingCollaboratorMobile: 'Add',
  investibleAddOthersExplanation: 'Add desired collaborators from outside this view.',

  // InvestibleAdd
  investibleAddTitleDefault: 'Add a name...',
  investibleAddTitleLabel: 'Name',
  investibleAddDescriptionDefault: 'Add a description...',
  investibleAddCancelLabel: 'Cancel',
  investibleAddSaveLabel: 'Save',
  skipApprovalExplanation: 'Skip getting approvals',
  newStory: 'New Job',
  DecideAssignMe: 'Assign to me',
  jobTypeLabelIMMEDIATE: 'Immediate - assign',
  jobTypeLabelAPPROVABLE: 'Approvable - assign for approval',
  jobTypeLabelREADY: 'Ready to assign - also in status',
  jobTypeLabelNOT_READY: 'Not ready - only in backlog',
  TaskLocalMoveLabel: 'Convert to task in current job',
  TaskOtherMoveLabel: 'Move to task in other job',
  SuggestionLocalMoveLabel: 'Convert to suggestion in current job',
  SuggestionOtherMoveLabel: 'Move to suggestion in other job',
  DiscussionOtherMoveLabel: 'Move to suggestion in discussion',
  TaskLabel: 'Task',
  SuggestionLabel: 'Suggestion in job',
  DiscussionLabel: 'Suggestion in discussion',
  BugLabel: 'Bug',
  BugMoveLabel: 'Convert to bug',
  JobMoveLabel: 'Move to task in job',
  DiscussionMoveLabel: 'Move to discussion',
  backlogReadyToStart: 'Backlog - Ready Assign',
  backlogNotReadyToStart: 'Backlog - Not Ready',
  jobCreate: 'Create job',
  jobCreateWithTasks: 'Create with tasks',

  // Investible
  investibleEditLabel: 'Edit',
  investibleAssignLabel: 'Assign',
  homeAssignments: 'Stories',
  investibleAssign: 'Job - Assignments',
  investibleFollow: 'Job - Following',
  investibleReviewers: 'Job - Required Reviewers',
  investibleApprovers: 'Job - Required Approvers',
  createAssignment: 'Assign',
  createAssignmentExplanation: 'Assign new job to this person.',
  investibleAssignForVotingLabel: 'Assign & Move Voting',
  investibleAddHeader: 'Add Investible',
  investibleEditStageHelper: 'Click to change stage',
  investibleEditInvestibleFetchFailed: 'There was a problem loading your investible for edit. Please try again later',
  investibleAddToVotingLabel: 'Move to Voting',
  investibleAddToVotingExplanation: 'Move to approvable option. Can be moved back to proposed later.',
  investibleRemoveFromVotingTitle: 'Move Out of Voting',
  investibleDeleteLabel: 'Permanently Delete',
  investibleDeleteExplanationLabel: 'Permanently remove this option from the dialog',
  planningInvestibleToVotingLabel: 'Approvable',
  planningMobileToVotingLabel: 'Approvable',
  inboxVotingLabel: 'Approvable',
  planningInvestibleNextStageAcceptedLabel: 'Doable',
  planningAcceptedStageLabel: 'Doable',
  startJobQ: 'Enough approvals?',
  finishApprovalQ: 'Ready for work?',
  otherOptionsQ: 'What to do with this job?',
  rejectAssignmentQ: 'Where to send this job?',
  planningInvestibleNextStageInReviewLabel: 'Reviewable',
  planningInvestibleMoveToVerifiedLabel: 'Reviewable',
  planningInvestibleMoveToFurtherWorkLabel: 'Backlog',
  planningInvestibleMoveToNotDoingLabel: 'Skippable',
  move: 'Move',
  planningInvestibleNotDoingExplanation: 'Move to Skippable will unassign and archive the job',
  planningVotingStageLabel: 'Approvable',
  verifiedBlockedStageLabel: 'Verified',
  planningReviewStageLabel: 'Reviewable',
  approvalsCountExplanation: 'Not enough approvals',
  inputRequiredCountExplanation: 'Open questions or suggestions for assignee',
  requiredReviewsCountExplanation: 'Open required reviews',
  openTasksCountExplanation: 'Open tasks',
  planningVerifiedStageLabel: 'Reviewable',
  planningFurtherWorkStageLabel: 'Backlog',
  requiresInputStageLabel: 'Debatable',
  assistanceUnresponded: 'Unresponded',
  assistanceResponded: 'Responded',
  assistanceResolved: 'Resolved',
  planningNotDoingStageLabel: 'Skippable',
  planningBlockedStageLabel: 'Debatable',
  allowedStagesDropdownLabel: 'Stage',
  nextStageDropdownLabel: 'Next stage',
  planningInvestibleAssignments: 'Assigned',
  requiredApprovers: 'Required approvers',
  addressed: 'Outside',
  planningInvestibleDecision: 'Add Dialog',
  missingEstimatedCompletion: 'No completion date',
  estimatedCompletionToday: 'Due',
  estimatedCompletionJustText: 'job due',
  planningInvestibleDescription: '- Description',
  mustRemoveTodosExplanation: 'Cannot change to this stage with open tasks',
  mustResolveAssignedQuestions: 'Cannot change to this stage with unresolved questions from an assignee',
  daysEstimateHelp: 'Optional very rough expected date of completion.',
  daysEstimateMarketLabel: 'date of completion',
  ticketSubCodeHelp: 'A short code for the view which will be used to form human readable job ids.',
  ticketSubCodeHelp1: 'Your job ids will look like U-{code}-0, U-{code}-1, U-{code}-2, etc.',
  groupNameHelp: 'A name for this view used in navigation and notification.',
  groupExplanationTooltip: 'A view is a different display and subset of workspace members.',
  workspaceExplanationTooltip: 'Members of a workspace see everything in all views.',
  voteExpirationHelp: "Days before approvals expire. Prevents approvals becoming too old.",
  startedExpirationHelp: "Days in Doable without progress report or estimated due date.",
  reassignToMove: 'Assigning moves to the swimlanes.',
  marketLinksSection: 'links',
  attachedFilesSection: 'Attach Files',
  attachededFilesSection: 'Attached Files',
  parentLinkSection: 'Parent',
  dialogNotParticipating: 'Click to become a collaborator',
  lockedBy: 'Locked by {x}',
  lockFailedWarning: 'Failed to acquire lock. Retry?',
  breakLock: 'Break lock',
  noVoters: 'None',
  reassignWarning: 'Re-assigning will remove all approval.',
  planningUnacceptedLabel: 'Unaccepted',
  planningAcceptLabel: 'Accept',
  wizardAcceptLabel: 'Move to task',
  ungroupLabel: 'Ungroup',
  moveToSuggestion: 'Move to suggestion',
  planningAcceptExplanation: 'Has not accepted this job.',
  // Issues
  issueResolveLabel: 'Resolve',
  issueReplyLabel: 'Reply',
  issueProceed: 'Proceed',
  requiresInputWarning: 'With these assignments, some comments require input.',
  proceedRequiresInput: 'Debatable',
  resolveComment: 'Resolve Comments',
  commentCloseNewStage: 'Resolving moves job to {x}.',
  numRepliesExplanation: 'Number in thread',
  // lock dialog
  lockDialogCancel: 'Cancel',
  pageLockEditPage: 'Edit Page',
  lockDialogTitle: 'Page locked',
  lockDialogContent: 'A user is currently editing this page, will you to take over editing?',

  // CommentAdd
  commentAddIssueDefault: 'Your issue...',
  commentAddTODODefault: 'Your task...',
  commentAddBugDefault: 'Your bug...',
  commentAddQuestionDefault: 'Your question...',
  commentAddSuggestDefault: 'Your suggestion...',
  commentAddReplyDefault: 'Your reply...',
  commentAddSubTaskDefault: 'Your grouped task...',
  commentAddReportDefault: "Report progress here, Ex: 'Made the button blue'",
  commentAddNoteDefault: 'Your note...',
  commentAddReportReview: "Explain what should be reviewed, Ex: 'Button is blue now.'",
  commentAddReviewReportDefault: 'Write your feedback here',
  commentAddSaveLabel: 'Save',
  commentAddSendLabel: 'Send',
  commentAddSendResolve: 'Send and resolve',
  commentAddSendDelegate: 'Send and delegate',
  commentAddSendAnother: 'Send and another',
  commentAddCancelLabel: 'Clear',
  commentAddSelectIssueLabel: 'Please select a type',
  issueWarning: 'Opening an issue will halt voting on this dialog.',
  noType: 'Choose a comment type.',
  proceedNormal: 'Everyone',
  proceedRestricted: 'Just me',
  removeCompressionExplanation: 'ctrl+alt+e (shortcut global) Show all comments.',

  // CommentBox
  commentIconRaiseIssueLabel: 'Raise issue',
  commentIconAskQuestionLabel: 'Ask question',
  commentIconSuggestChangesLabel: 'Suggest changes',
  manualSync: 'Manual sync',
  manualSyncExplanation: 'Sync all workspaces with the server',

  // Comments
  commentReplyDefault: 'Your reply...',
  commentReplyLabel: 'Reply',
  commentSubTaskLabel: 'Grouped',
  commentGroupedTaskLabel: 'Grouped task',
  commentEditLabel: 'Edit',
  commentReplyCancelLabel: 'Cancel',
  commentReopenLabel: 'Reopen',
  commentResolveLabel: 'Resolve',
  commentDelegateLabel: 'Delegate',
  commentDelegateExplanation: 'Delegate this choice to AI without selecting an option.',
  commentResolveLabelInstead: 'Resolve instead',
  commentResolveLabelOnly: 'Resolve only',
  UnblockReplyLabel: 'Reply',
  commentAbstainLabel: 'Mute',
  commentUnmuteLabel: 'Unmute',
  commentAbstainingLabel: 'Muted',
  snoozedLabel: 'Snoozed',
  poke: 'Poke',
  pokeAI: 'Poke AI',
  pokeAIJobTooltip: 'Send `{command}` to your connected AI terminal.',
  poked: 'Poked',
  pokedExplanation: 'This notification was poked by its author to increase urgency.',
  pokedBugExplanation: 'This bug was poked by its author to increase urgency.',
  pictureBugPlaceholder: 'Picture',
  commentRemoveLabel: 'Delete',
  commentCloseThreadLabel: 'Collapse',
  commentCloseThreadLabelExplanation: 'ctrl+shift+e to globally collapse',
  lastUpdatedBy: ' by',
  comments: 'Comments',
  JobCommentConfigure: 'Create option',
  JobCommentCreateAnotherOption: 'Create and another',
  JobOptionTerminate: 'Go to question',
  DecideStartNavigate: 'Go to bug',
  DiscussionCommentAddQUESTION: 'Add options',
  DiscussionCommentAddSUGGEST: 'Add suggestion',
  DiscussionCommentAddREPORT: 'Add note',
  JobCommentAddQUESTION: 'Add options',
  JobCommentAddSUGGEST: 'Add',
  JobCommentAddISSUE: 'Add',
  JobCommentAddTODO: 'Add',
  JobCommentAddREPORT: 'Add',
  addAnother: 'Add and another',
  addResolve: 'Add and resolve',
  addDelegate: 'Add and delegate',
  DecisionCommentAddQUESTION: 'Add',
  DecisionCommentAddSUGGEST: 'Add',
  DecisionCommentAddISSUE: 'Add',
  DecisionCommentAddTODO: 'Add',
  commentTypeLabelREPLY: 'Reply',
  commentTypeLabelREPORT: 'Note',
  commentTypeLabelSubTaskREPLY: 'Grouped task',
  groupedTaskChosenHint: 'Use the Grouped button drop down to create a note instead.',
  groupedNoteChosenHint: 'Use the Grouped button drop down to create a grouped task instead.',
  addNote: 'Add note',

  // card types
  cardTypeLabelIssue: 'Blocker',
  cardTypeLabelTask: 'Task',
  cardTypeLabelQuestion: 'Question',
  cardTypeLabelSuggestedChange: 'Suggestion',
  cardTypeLabelTodo: 'task',
  cardTypeLabelProgressReport: 'progress report',
  cardTypeAgilePlan: 'view - description',

  // Notices
  noticeNewApplicationVersion: 'A new version is available! Refresh this page for the latest.',
  noticeVersionForceLogout: 'This version of the application requires signout which will happen when you close this message.',
  noticeScriptReinstall: 'The Uclusion AI connection has been updated. Your AI client will offer to install the update at the start of your next session, or run "uclusion update" in a terminal.',
  notifications: 'inbox',
  notification: 'notification',
  notificationDelete: 'Dismiss',
  informational: 'Informational',
  mentionsExplanation: 'Count of mentions for this person to process',
  approvalExplanation: 'Count of required approvals for this person to process',
  backToInboxWizard: 'Back to inbox wizard',

  // stages
  marketStageFollowTooltip: 'Subscribe',
  marketStageUnFollowTooltip: 'Unsubscribe',

  // markets
  signupInvite: 'invites you to collaborate in',
  signupRedirectLogin: 'Create account will redirect you to login.',
  switchWorkspace: 'Other workspaces',
  switchGroup: 'View',
  archivedWorkspace: 'Archived',
  editWorkspace: 'Edit workspace',
  notificationMarketSettingsExplanation: 'Change notification settings of the chosen workspace',

  // Rich text editor
  RichTextEditorAddLinkTitle: 'Add Link',
  RichTextEditorEnterUrl: 'Enter the URL of the link:',
  RichTextEditorEnterTextAndLink: 'Enter the URL and text of the link:',
  RichTextEditorLinkLabel: 'Link',
  RichTextEditorTextLabel: 'Text',
  RichTextEditorToManyBytes: 'To much data. Please remove items from the editor',

  // Investible detail
  investibleDetailClose: 'Close',
  chooseDate: 'Change estimated completion date',
  orProgressReport: 'or create or update a progress report.',
  orProgressReportOnly: 'or create a progress report.',
  descriptionVotingLabel: 'Overview',
  planningInvestibleOpenLabel: 'Details',

  // Home
  homeAddPlanning: 'New workspace',
  homeAddGroup: 'New view',
  archiveWarning: 'Muting will unassign any active job. Deactivating stops for everyone.',
  new: 'new',
  match: 'match',
  searchGoToMatch: 'Go to first match',
  votes: 'votes',
  tasks: 'tasks',
  review: 'review',
  open: 'open',
  total: 'total',
  openHeader: 'Open',
  information: 'Information',
  message: 'Message',
  messages: 'Messages',
  // Archives
  archivesTitle: 'Archive',
  inboxMarkRead: 'Mark selected read',
  outboxMark: 'Poke selected',
  inboxArchive: 'Delete selected',
  inboxCollapseAll: 'ctrl+alt+e Collapse All',
  inboxExpandAll: 'ctrl+shift+e Expand All',
  backToInbox: 'ctrl+arrowUp Back to inbox',

  // Planning Dialog
  planningDialogNavDetailsLabel: 'Details',
  planningDialogNavStoriesLabel: 'Job Progress',
  planningDialogBacklog: 'Job Backlog',
  planningDialogNavDiscussionLabel: 'Discussion',
  planningDialogManageParticipantsLabel: 'Manage collaborators',
  planningDialogDiscussionLabel: 'Notes / Discussion',
  todosSelectForStory: 'Select bugs for job',
  todosCreateStory: 'Create job from bugs',
  todosMove: 'Move tasks',
  planningDialogAddInvestibleExplanation: 'Create a job and collaborate on what to do',
  planningDialogViewArchivesLabel: 'Archive',
  seeArchives: 'See muted',
  removeArchive: 'See less',
  stageUpdatedAt: 'Entered ',
  noName: 'Must create a text description for this job.',
  noParticipants: 'Include at least one person to send.',
  nameRequired: 'Choose a name.',
  noQuantity: 'Choose a certainty.',
  noVoteQuantity: 'Choose a certainty.',
  noMultiplier: 'Choose for or against.',
  noQuestions: 'Questions should go in their own comment.',
  noQuestionUploads: 'Questions should go in their own comment.',
  collaborators: 'Collaborators',
  addMoreCollaborators: 'Invite more people',
  more: 'More',
  less: 'Less',
  onlyThisGroup: 'Only this view',
  inlineAddLabel: 'Add option',
  inlineProposeLabel: 'Propose option',
  inlineAddLabelMobile: 'Option',
  promoteOption: 'Allow voting',
  promoteOptionExplanation: 'Move option to approvable stage for voting',
  demoteOption: 'Prevent voting',
  demoteOptionExplanation: 'Move option to proposed stage and stop voting',
  addStoryLabel: 'Add job',
  createDialogApprovableExplanation: 'New approvable option',
  createDialogProposedExplanation: 'New proposed option',
  allowVoteSuggestion: 'Allow voting',
  noVoteSuggestion: 'Add without voting',
  voteSuggestion: 'Add with voting',
  allowVoteSuggestionMobile: 'Voting',
  uploadFilesDisplay: 'Attach New Files',
  uploadFilesTooltip: 'Drag files here or click to attach new files',
  uploadInProgress: 'Uploading Files',
  inlineAddExplanation: 'Add options for how to do this job and collect approval.',
  deactivateInlineQuestion: 'Changing stage will deactivate any dialogs associated with this job.',
  deactivateDialogQuestion: 'Do you want to deactivate and stop any further work?',
  activateDialogQuestion: 'This view is inactive. Do you want to activate and continue work?',
  changeStage: 'Change stage',
  planningMarketActivate: 'Activate view',
  tabGroupAppend: '(View)',
  immediateLower: 'critical',
  openLower: 'open',
  immediate: 'Critical',
  immediateToolTip: 'Critical bugs remain in the inbox notification until moved or resolved.',
  normalToolTip: 'Normal bugs send a dismissable notification.',
  minorToolTip: 'Minor bugs do not send notifications.',
  notReadyToolTip: 'Not Ready jobs do not display on job status.',
  notDoingBacklogToolTip: 'Skippable jobs are dormant and unassigned but kept for reference.',
  assignReadyJobsToolTip: 'Ready to assign jobs also display on the job status page.',
  statusJobsToolTip: 'This page shows all assignments and jobs needing help',
  backlogJobsToolTip: 'Discuss jobs while waiting for an assignee.',
  bugsToolTip: 'Open a prioritized bug that later can be moved to a job.',
  discussionToolTip: 'Suggestions and questions can later be moved to jobs.',
  votedOptionsToolTip: 'Only options promoted by the question creator can be approved.',
  proposedOptionsToolTip: 'Options here wait for promotion by the question creator or are permanently blocked.',
  forYouToolTip: 'Events by others create notifications that display here.',
  fromYouToolTip: 'Your questions, suggestions, and assignments display here for processing or poking.',
  openTasksToolTip: 'Overview of open tasks for this job',
  resolvedTasksToolTip: 'Overview of resolved tasks for this job.',
  jobOverviewToolTip: 'Overview of tasks, approvals, and status for this job.',
  jobTasksToolTip: 'All open tasks for this job.',
  jobNotesToolTip: 'All job task and job level notes.',
  jobAssistanceToolTip: 'Questions, suggestions, and blockers for this job.',
  collaboratorsExplanation: 'Active participants in this job show as collaborators',
  storyFromComment: 'Move',
  makeTask: 'Make task',
  makeTaskExplanation: 'Make a task with a link to this option',
  makeBug: 'Make bug',
  storyFromCommentNav: 'Move and go to job',
  channelOptions: 'View Options',
  marketOptions: 'Workspace Options',
  marketName: 'Choose a name for the new workspace.',
  mutingExplanation: 'Muting prevents notifications unless you are mentioned, assigned or a required approver or reviewer.',
  groupDiscussionDesc: 'About and links to external view info',
  QUESTIONYesConfig: 'Allow approve multiple options',
  QUESTIONNoConfig: 'Allow approve only one option',
  SUGGESTYesConfig: 'Everyone sees results',
  SUGGESTNoConfig: 'Only you see results',
  ISSUEYesConfig: 'The team will be notified to help',
  ISSUENoConfig: 'No notifications',
  singlePersonMode: 'Single person mode',

  // Decision Dialog
  decisionDialogCurrentVotingLabel: 'Approvable Options',
  decisionDialogProposedOptionsLabel: 'Proposed Options',
  decisionDialogDiscussionLabel: 'Discussion',
  decisionDialogAddInvestibleLabel: 'Add',
  decisionDialogAddExplanationLabel: 'Add a new approvable option',
  decisionDialogProposeInvestibleLabel: 'Add',
  decisionDialogProposeExplanationLabel: 'Add a new proposed option',
  decisionDialogExtendDaysLabel: 'Number of days to extend deadline?',
  decisionDialogNoInvestiblesWarning: 'No votable options',
  decisionAddHelp: 'A Dialog gives you a timed box way to decide with others between options that you control.',
  backToOptionPoolWarning: 'Moving this option back to Proposed Options deletes all approval.',
  yesAndProceedDeactive: 'Archive and deactivate',
  noAndProceedDeactivate: 'Archive only',
  proceedActivate: 'Activate view',
  // Investibles in decision dialog display
  decisionDialogInvestiblesUpdatedAt: 'Last Updated:',
  dialogAddParticipantsLabel: 'Add collaborators',
  planningMarketSubscribeExplanation: 'Subscribe to approvals and reviews',
  planningMarketUnSubscribeExplanation: 'Unsubscribe from approvals and reviews',
  storyAddParticipantsLabel: 'Change assigned',
  storyApproversLabel: 'Change required approvers',
  addApproversLabel: 'Require approvers',
  doneApprovalLabel: 'Yes - Doable',
  moveSuggestionLabel: 'Move suggestion',
  notDoneApprovalLabel: 'No - other options',
  otherOptionsLabel: 'Other options',
  commentInJob: 'Comment in job',
  storyReviewersLabel: 'Change required reviewers',
  storyAddressedLabel: 'Add or remove collaborators to receive notifications on this job.',
  dialogEditExpiresLabel: 'Add Time',
  dialogExpiresLabel: 'Once the Dialog expires it is frozen for changes and cannot be re-activated.',
  searchParticipantsLabel: 'Search in Uclusion',
  searchParticipantsPlaceholder: 'Enter after each email address',
  inviteParticipantsEmailLabel: 'Add by email addresses',
  collaboratorNotFollowing: 'This user will not receive notifications.',

  // DecisionIvestibleSave
  decisionInvestibleSaveAddAnother: 'Save & Add Another',
  decisionInvestibleMobileAddAnother: '& Another',

  // DecisionInvestible
  decisionInvestibleYourVoting: 'Your Input',
  decisionInvestibleOthersVoting: 'Approvals',
  createApprovalExplanation: 'Create a new approval for this option',
  decisionInvestibleDescription: 'Option - Description',
  decisionProposedInvestibleDescription: 'Proposed Option - Description',
  decisionInvestibleDiscussion: 'Discussion',
  decisionInvestibleVotingBlockedMarket: 'Voting suspended until the open issue on this dialog is resolved',
  decisionInvestibleVotingBlockedInvestible: 'Voting suspended until the open issue on this option is resolved',

  // InitiativeInvestible
  initiativeInvestibleVotingBlocked: 'Voting is blocked because there is an open issue',
  initiativeInvestibleYourVoting: 'Your Input',
  initiativeInvestibleOthersVoting: 'Options',
  initiativeInvestibleDescription: 'Initiative - Description',
  investibleDescription: 'Job - Add',
  dialogDescription: 'Dialog - Description',
  dialogAddress: 'Add collaborators',
  planAddress: 'Add collaborators',
  initiativeAddress: 'Add collaborators',
  dialogExtend: 'Dialog - Delay expiration',
  initiativeExtend: 'Initiative - Delay expiration',
  initiativeInvestibleDiscussion: 'Discussion',
  initiativeVotingFor: 'For',
  initiativeVotingAgainst: 'Against',
  initiativeAddHelp: 'Create an initiative to quickly gather opinions on your next potential project.',

  // About
  sidebarNavAbout: 'About',
  aboutApplicationVersionLabel: 'Version',
  aboutMarketIdLabel: 'Dialog ID',
  aboutAccountIdLabel: 'Account ID',
  aboutAccountNameLabel: 'Account Name',
  aboutUserIdLabel: 'User ID',
  aboutUserNameLabel: 'User Name',
  aboutUclusionEmailLabel: 'Support',
  aboutClearStorageButton: 'Clear Storage',

  // Quill Editor
  quillEditorUploadInProgress: 'Uploading image(s)',

  // diff displaydeci
  diffDisplayDismissLabel: 'Hide change',
  diffDisplayShowLabel: 'Last change',

  // expiration extender
  deadlineExtenderSave: 'Modify',
  deadlineExtenderCancel: 'Close',
  allowMultiVote: 'Can collaborator\'s approve more than one option?',
  allowMultiVoteQuestion: 'Allow approve multiple options?',
  allowMultiVoteQuestionMobile: 'Allow multi-option?',

  // invite linker
  inviteLinkerDirectionsDecision: 'Share link',
  inviteLinkerDirectionsPlan: 'Click to copy link',
  commitMessageDirections: 'Click to copy commit message',
  codeOnlyDirections: 'Click to copy code only',
  inviteLinkerCopied: 'Link copied to clipboard',
  commitMessageCopied: 'Commit message copied to clipboard',
  codeOnlyCopied: 'Code copied to clipboard',
  inviteLinkerDirectionsInitiative: 'Share link',
  inviteLinkerCopyToClipboard: 'Copy to clipboard',

  // Assignment List
  assignmentListHeader: 'Assigned to',
  emptyAssignmentHeader: 'Unassigned goes to Backlog',
  requiresInputListHeader: 'Warning: unless you resolve some comments the current assignment will move the job to Debatable.',
  reviewListHeader: 'Required reviewers (X to remove)',
  approveListHeader: 'Required approvers (X to remove)',
  followingListHeader: 'Following (X to remove)',
  removeExplanation: 'Remove takes away all access to this workspace',
  groupRemoveExplanation: 'Unchecking removes this user from this view',
  groupRemoveAction: 'Active',
  mutedExplanation: 'Muted view',
  muteAction: 'Mute view',
  searchAssignments: 'Choose',
  everyoneGroupExplanation: 'This view automatically has everyone in the workspace as a member.',
  everyoneGroupAddExplanation: 'This view automatically contains everyone and you can add to the workspace below.',
  everyoneInGroupAddExplanation: 'This view already contains everyone in the workspace.',
  searchAssigned: 'Assigned to me',
  searchAssignedMobile: 'Assigned',
  searchActive: 'Active',
  sameView: 'Same view',
  nextGroup: 'Next view',

  // Address List
  addressListHeader: 'Addressed to',
  todoAddressListHeader: 'Assign to',
  addressListMakeObserver: 'Make Yourself an Observer',
  addressListMakeParticipant: 'Make Yourself a Participant',
  work: 'Solo view',

  // Dialog Archives
  dialogArchivesNotDoingHeader: 'Skippable',
  dialogArchivesVerifiedHeader: 'Reviewable',
  dialogArchivesLabel: 'View Archive',
  showAllComplete: 'Show all',
  completeJobsTitle: 'Reviewable Jobs',
  viewFilterLabel: 'Show jobs for view:',
  viewFilterAll: 'All views',
  readyFurtherWorkHeader: 'Backlog',
  readyToStartHeader: 'Ready to Assign',
  notReadyToStartHeader: 'Not Ready',
  notDoingHeader: 'Skippable',
  backlogReadyToStartHeader: 'Backlog - Ready to Assign',
  backlogNotReadyToStartHeader: 'Backlog - Not Ready',
  backlogNotDoingHeader: 'Backlog - Skippable',
  blockedHeader: 'Next / Debatable',

  // SignIn
  signInEmailLabel: 'Email',
  signInPasswordLabel: 'Password',
  signInNoAccount: 'Don\'t have an account? Sign up',
  signInForgotPassword: 'Forgot Password?',
  signInSignIn: 'Sign In',
  signInGithubSignIn: 'Sign In with GitHub',
  signInGoogleSignIn: 'Sign In with Google',

  // Agent setup approval
  setupTitle: 'Connect Uclusion',
  setupLoading: 'Loading this setup request…',
  setupFinishingAccount: 'Finishing account setup… This can take a few seconds after Google or GitHub sign-in.',
  setupRetryable: 'Uclusion could not load this setup request yet. You can safely try again.',
  setupRetry: 'Try again',
  setupReviewPrompt: 'Review the exact setup your coding agent requested. Nothing is created until you approve.',
  setupWorkspace: 'Workspace',
  setupClient: 'AI client',
  setupScope: 'Install scope',
  setupScopeGlobal: 'Global — available in all projects',
  setupScopeProject: 'Current project',
  setupTokenAudit: 'Token usage notes',
  setupWorkClaims: 'Work-claim locking',
  setupEnabled: 'On',
  setupDisabled: 'Off',
  setupCurrentAccount: 'Approving account',
  setupExpires: 'This request expires {expiry}.',
  setupApprove: 'Approve',
  setupDeny: 'Deny',
  setupApprovedTitle: 'Setup approved',
  setupApprovedBody: 'Return to your coding agent. It can now finish connecting Uclusion.',
  setupCompletingBody: 'Your coding agent is finishing this setup. Return to it for the next instruction.',
  setupDeniedTitle: 'Setup denied',
  setupDeniedBody: 'Nothing was created. Return to your coding agent if you want to start a new setup.',
  setupExpiredTitle: 'Setup expired',
  setupExpiredBody: 'This approval link is no longer active. Return to your coding agent to start a new setup.',
  setupConsumedTitle: 'Setup complete',
  setupConsumedBody: '{workspace} was created. Opening it now…',
  setupWorkspaceOpenFailed: 'Uclusion could not open the workspace automatically. Reload this page to try again.',
  setupWrongAccountTitle: 'Different account',
  setupWrongAccountBody: 'This setup was approved with a different Uclusion account. Sign in with that account or start a new setup.',
  setupSwitchAccount: 'Switch account',
  setupUnavailableTitle: 'Setup unavailable',
  setupUnavailableBody: 'This setup link is invalid or no longer available. Return to your coding agent to start a new setup.',


  // Signup
  signupNameLabel: 'Name',
  signupEmailLabel: 'Email',
  signupEmailDotPlacementHelper: 'Email cannot start or end with a period or contain consecutive periods',
  signupEmailLengthHelper: 'Email must be 128 characters or fewer',
  signupPasswordLabel: 'Password',
  signupPasswordHelper: '6 Characters Minimum',
  signupPasswordRepeatLabel: 'Repeat Password',
  signupPasswordRepeatHelper: 'Must match Password',
  signupSignupLabel: 'Create Account',
  signupTitle: 'Connect your AI agent for free.',
  signupHaveAccount: 'Already have an account? Sign in',
  signupAccountExists: 'An account with that email already exists, please log in.',
  signupAccountExistsLoginLink: 'Log In',
  signupSentEmail: 'We have sent a verification email to you. Please click the link inside to continue.',
  signupCreatedUser: 'Your user is created, and a verification link has been sent to your email {email}. Please click the link inside to continue.',
  signupResendCodeButton: 'Resend Link',
  signupAgreeTermsOfUse: 'By signing up I agree to the Uclusion ',
  signupTermsOfUse: 'Terms of Use',
  signupGithubSignup: 'Sign Up with GitHub',
  signupGoogleSignup: 'Sign Up with Google',
  signInNotVerified: 'Your email ({email}) has not been verified yet. In order to use Uclusion you must verify your email address via the link we sent to your email. If you do not have that link, you may get a new one by clicking Resend Link.',

  // Forgot Password
  forgotPasswordHeader: 'Reset your password',
  forgotPasswordEmailLabel: 'Enter your email address',
  forgotPasswordCodeLabel: 'Reset Code',
  forgotPasswordNewPasswordLabel: 'New Password',
  forgotPasswordRepeatLabel: 'Repeat New Password',
  forgotPasswordSendCodeButton: 'Send Reset Code',
  forgotPasswordResetPasswordButton: 'Submit',
  forgotPasswordResendCode: 'Resend Reset Code',
  forgotPasswordEmailNotFound: 'That email address was not found',
  forgotPasswordInvalidCode: 'An invalid code was entered',
  forgotPasswordHelper: '6 Characters Minimum',
  forgotPasswordRepeatHelper: 'Must match Password',

  // Change Password
  errorChangePasswordFailed: 'Change password failed. Please try again.',
  userPreferencesHeader: 'Manage account',
  changePasswordHeader: 'Change password',
  changePasswordNewLabel: 'New password',
  changePasswordRepeatLabel: 'Repeat new password',
  changePasswordOldLabel: 'Old password',
  changePasswordButton: 'Change Password',

  // Sign out
  signOutButton: 'Sign Out',
  errorSignOutFailed: 'Sign out failed. Please try again.',

  // Change Preferences
  integrationPreferencesHeader: 'Integrations',
  slackIntegrationExplanation: 'Add or remove Slack integration',
  slackIntegration: 'Slack',
  cliIntegration: 'AI Connection',
  cliIntegrationExplanation: 'Sync notes and TODOs with jobs and bugs in Uclusion',
  changePreferences: 'Email and Slack notification preferences by workspace',
  emailEnabledLabel: 'Send notifications via email',
  slackEnabledLabel: 'Send notifications via Slack',
  changePreferencesButton: 'Update Preferences',
  preferences: 'Preferences',
  slackDelayInputLabel: 'Time between alerts',
  emailDelayInputLabel: 'Time between emails for priority',
  emailDelayYellowInputLabel: 'Time between emails for not priority',
  emailDelayExplanation: 'Minimum time after notification before sending another for priority.',
  emailDelayYellowExplanation: 'Minimum time after notification before sending another for not priority.',
  slackDelayExplanation: 'Minimum time after a Slack notification before sending another.',
  doNotShowAgain: 'Do not show again',

  // your voting
  yourVotingVoteForThisPlanning: 'Approve this job',
  yourVotingVoteForThisDecision: 'Approve this option',
  approveAndGotoJob: 'Approve and go to job',
  stageAndGotoJob: 'Move and go to job',
  modifyTasks: 'Modify tasks',
  voteFor: 'Vote for',
  voteAgainst: 'Vote against',
  clearVotes: 'Your other approval will be cleared',
  addAVote: 'Approve your preferred option',
  addMultiVote: 'Approve all options you consider desirable',
  pleaseVoteStory: 'Approve this assignment',
  orStructuredComment: 'Or create a comment',
  voteDeletedStory: 'Your approval was deleted or expired. Save or modify to approve again.',
  changeVote: 'Change approval',
  changeVoteInitiative: 'Change vote',
  personChooserLabel: 'View Other Person\'s Assignments',
  clear: 'Clear',

  // add participants
  addParticipantsNewPerson: 'Not in the list? Send invite.',
  emailsSentLabel: 'Sent emails to',

  // Spinning
  spinVersionCheckError: 'There was an error. Please retry your operation.',
  loadImageError: 'Issue saving image. Refresh this page so you can retry.',
  errorCommentUpdateUnchanged: 'The comment has not changed. Make an edit before updating.',

  // subscription page
  BillingHomeTitle: 'Billing Plan',

  //upgradeMenu
  billingMenuItem: 'Billing plan',
  billingFreeTier: 'You are currently on a free plan.',
  billingStandardTier: 'You are currently on a paid plan.',
  billingSubCanceled: 'Your subscription was canceled.',
  billingSubUnsubscribed: 'You have not subscribed to any plan.',
  billingSubTrial: 'Your free trial ends on {date}. Afterwards the charge is {price} monthly.',
  billingSubActive: 'Your subscription is active and charges {price} monthly.',
  billingNeedCard: 'Please add a card or use a promo code.',
  billingSubFree: 'If you add a second user free ends, but a free trial period will begin.',
  billingSubEnd: 'Your subscription will renew on {date}:',
  billingSubRestart: 'Restart subscription',
  billingSubCancel: 'Cancel subscription',
  billingMustPay: 'Create not available because trial period is over. Please go to \'Your Plan\' to update your billing information.',
  billingStartSubscription: 'Please go to manage subscription and start a free trial to enable create.',

  // payment info
  paymentInfoButtonAdd: 'Add a card',
  paymentInfoButtonUpdate: 'Update your card',
  WizardPaymentInfo: 'Add or update card',
  WizardPromoInfo: 'Apply promotion code',
  DecidePayTitle: 'Will you pay?',
  GroupWelcome: 'Welcome to a new view',
  WorkspaceWelcome: 'Welcome to the workspace',
  DemoWelcome: 'Welcome to the demo',
  ApplyPromoCode: 'Apply promo code',

  // upgrade form
  upgradeFormCardName: 'Cardholder name',
  upgradeFormCardPhone: 'Cardholder phone number',
  upgradeFormCardEmail: 'Cardholder email',
  upgradeFormUpgradeLabel: 'Update card',
  upgradeFormRestartLabel: 'Restart subscription',

  // API errors
  errorUnnamedMarketAddFailed: 'There was a problem sending. Please try again.',
  errorDecisionInvestibleAddFailed: 'There was a problem adding the option.',
  errorInvestibleAddFailed: 'There was a problem adding.',
  errorInvestibleDeleteFailed: 'There was a problem deleting.',
  errorPlanningInvestibleAddFailed: 'There was a problem adding the job',
  errorInvestibleStageChangeFailed: 'There was a problem changing the stage of this job',
  errorInvestibleUpdateFailed: 'There was a problem updating.',
  errorCommentFetchFailed: 'There was a problem retrieving comments',
  errorUsersFetchFailed: 'There was a problem retrieving users',
  errorCommentSaveFailed: 'There was a problem saving your comment',
  errorInvestmentUpdateFailed: 'There was a problem updating your approval',
  errorQuestionResolved: 'This question has been resolved',
  errorAddParticipantsFailed: 'There was a problem adding participants',
  errorInviteParticipantsFailed: 'There was a problem inviting participants',
  errorDecisionAddFailed: 'There was a problem creating your Dialog',
  errorInitiativeAddFailed: 'There was a problem creating your Initiative',
  errorPlanningAddFailed: 'There was a problem creating your workspace',
  errorGroupAddFailed: 'There was a problem creating your view',
  errorFileUploadFailed: 'There was a problem uploading your file',
  errorEditLockFailed: 'There was a problem getting permission to edit',
  errorAcceptInvestibleFailed: 'There was a problem accepting the job. Please try again.',
  errorEditLockReleaseFailed: 'There was a problem releasing edit permission',
  errorSubmitToModeratorFailed: 'There was a problem submitting to the moderator',
  errorChangeToObserverFailed: 'There was a problem changing to approver',
  errorFollowStages: 'There was an error subscribing to the view',
  errorUnFollowStages: 'There was an error un-subscribing from the view',
  errorChangeToParticipantFailed: 'There was a problem changing to collaborator',
  errorMarketUpdateFailed: 'There was a problem editing the workspace',
  errorGroupUpdateFailed: 'There was a problem editing the view',
  errorMarketExpirationExtendFailed: 'There was a problem extending the deadline',
  errorMarketAttachFilesFailed: 'There was a problem attaching your files',
  errorInvestibleAttachFilesFailed: 'There was a problem attaching your files',
  errorInvestibleRemoveAttachedFilesFailed: 'There was a problem removing your files',
  errorMarketRemoveAttachedFilesFailed: 'There was a problem removing your files',
  errorMarketShowFailed: 'There was a problem restoring the dialog',
  errorMarketHideFailed: 'There was a problem dismissing the dialog',
  errorCommentResolveFailed: 'There was a problem resolving',
  errorCommentDeleteFailed: 'There was a problem removing',
  errorCommentMoveFailed: 'There was a problem moving comments',
  errorCommentReopenFailed: 'There was a problem reopening',
  errorMarketArchiveFailed: 'There was a problem deactivating the dialog',
  errorMarketActivateFailed: 'There was a problem activating the view',
  errorInvestibleMoveToCurrentVotingFailed: 'There was a problem moving the option to Options. Please try again.',
  errorInvestibleMoveToOptionPoolFailed: 'There was a problem moving the option back to Proposed Options. Please try again.',
  errorInvestibleFetchFailed: 'There was a problem receiving the job',
  errorStagesFetchFailed: 'There was a problem receiving the stages',
  errorGroupFetchFailed: 'There was a problem receiving the views',
  errorGroupMembersFetchFailed: 'There was a problem receiving the view members',
  errorInvestmentsFetchFailed: 'There was a problem receiving the voting',
  errorInvestibleListFetchFailed: 'There was a problem fetching the data list',
  errorSignupFailed: 'There was a problem signing up. Please try again',
  errorResendFailed: 'There was a problem resending the link. Please try again',
  errorVerifyFailed: 'There was a problem verifying your email. Please try again',
  errorForgotPasswordCodeFailed: 'There was a problem sending your reset code. Please try again',
  errorForgotPasswordSetFailed: 'There was an error changing your password. Please try again',
  errorClearFailed: 'There was a problem clearing your data. Please try again',
  errorGetIdFailed: 'There was a problem displaying your identification.',
  errorUpdateUserFailed: 'There was a problem updating your profile. Please try again.',
  errorUpdateAbstainFailed: 'There was a problem updating your user. Please try again.',
  errorUpdateStageFailed: 'There was a problem updating allowed jobs. Please try again.',
  errorMarketFetchFailed: 'There was an error processing your invite. Please try again.',
  errorBanUserFailed: 'There was a problem removing the collaborator. Please try again.',
  errorSecretFailed: 'There was a problem retrieving the secret. Please try again.',
  errorNewSecretFailed: 'There was a problem retrieving the new secret. Please try again.',
  errorPokeFailed: 'There was a problem poking. Please try again.',
  errorPokeAIFailed: 'There was a problem poking AI. Please try again.',
  errorGuestUserFailed: 'There was a problem changing the collaborator. Please try again.',
  errorCancelSubFailed: 'There was a problem cancelling your subscription. Please try again.',
  errorStartSubFailed: 'There was a problem starting your subscription. Please try again.',
  errorPromoValidateFailed: 'There was a problem validating your promo code. Please try again',
  errorPromoApplyFailed: 'There was a problem applying your promo code. Please try again',
  errorRestartSubFailed: 'There was a problem restarting your subscription. Please try again.',
  errorUnbanUserFailed: 'There was a problem readmitting the collaborator. Please try again.',
  errorUpdatePaymentFailed: 'There was a problem updating your payment card. Please try again.',
  errorHomeUserFetchFailed: 'There was a problem fetching your user. Please try again.',
  errorMarketLoginFailed: 'There was a problem authenticating the operation. Please try again.',
  errorPreferenceUpdateFailed: 'There was a problem updating your preferences. Please try again.',
  errorUserLoadFailed: 'We could not load your user. Please login again.',
  errorDemoLoadFailed: 'We could not load your demo. Please login again.',
  warningAlreadyInMarket: 'You are already a part of this market.',
  homeStartTour: 'Start Tour',
  //summary
  summaryExpiredAt: 'Expired on {expireDate}',
  expiring: 'Expiring',
  expiresIn: 'Expires in ',

  //assigneeFilterDropdown
  assigneeFilterDropdownAll: 'Everyone',
  assigneeFilterLabel: 'Show jobs for:',

  //show investibles dropdown
  showInvestiblesDropdownHelp: 'Number of jobs to allow in Reviewable swimlane per person',
  showInvestiblesDropdownAgeHelp: 'Maximum age of jobs shown in Reviewable swimlanes.',
  showInvestiblesDropdownLabel: 'Maximum verified jobs shown in swimlane',
  showInvestiblesDropdownAgeLabel: 'Maximum age in days to show Reviewable jobs',
  showInvestiblesUnlimitedValue: 'Unlimited',
  planningArchiveCollapse: 'Hide Next / Debatable jobs',
  planningArchiveExpand: 'Show Next / Debatable jobs',

  // warnings
  warningOffline: 'You are offline',
  optionalEdit: 'These fields are optional and can be changed at any time',

  // Inbox row titles
  DecideAssignTitle: 'Will you reassign?',
  DecideStageTitle: 'Move this job?',
  AssignmentApprovalRowTitle: 'Will you approve?',
  AssignmentApprovalTitle: 'How certain are you of approving this job?',
  DecideAnswerTitle: 'Can you help answer?',
  DecideVoteTitle: 'How do you vote?',
  DecideResponseTitle: 'How do you respond?',
  inOptionLabel: 'In option',
  DecideIdeaTitle: 'Good idea?',
  DecidePromotionTitle: 'Allow voting on option?',
  JobStatusTitle: 'Will you update?',
  JobMovedTitle: 'Okay job moved back?',
  DecideAcceptRejectTitle: 'Follow this suggestion?',
  DecideUnblockTitle: 'Help unblock?',
  NewTaskTitle: 'Questions on this task?',
  NewTasksTitle: 'Questions on these tasks?',
  DecideResolveReopenTitle: 'Do you reopen?',
  DecideResolveTitle: 'Can you resolve?',
  DecideStartTitle: 'Can you start this bug?',
  CriticalBugTitle: 'Can you assign?',
  DecideReviewTitle: 'Will you review?',
  ReviewDesignTitle: 'Review design?',
  ReviewDesignStage: 'The job is in stage {stage}.',
  ReviewAINoteTitle: 'Review AI note?',
  ReviewAINoteExplanation: 'Edit the AI-maintained note if it needs changes, or dismiss it when the guidance is ready.',
  editNote: 'Edit note',
  pauseImplementation: 'Pause implementation',
  startImplementation: 'Start implementation',
  DecideAssignmentTitle: 'Take this job?',

  // Comments
  RequestWorkTitle: 'AI asking for work',
  messagePresent: 'Go to notification for this job',
  messagePresentComment: 'Click to go to notification',
  messagePresentCommentChoice: 'Click to go to or clear notification',
  notificationGoTo: 'Go to notification',
  notificationGoToBug: 'Go to bug',
  notificationGoToQuestion: 'Go to question',
  notificationGoToSuggestion: 'Go to suggestion',
  notificationGoToTask: 'Go to task',
  notificationClear: 'Clear notification',
  issuePresent: 'Blocking issue',
  nonBlockIssuePresent: 'Issue',
  questionPresent: 'Assignee has question',
  suggestPresent: 'Assignee has suggestion',
  suggestPresentBacklog: 'Open suggestion',
  questionPresentBacklog: 'Open question',
  reportPresent: 'Progress Report',
  reviewReportPresent: 'Review Report',
  issueCompose: 'Blocking issue - asks for help clearing the blocker',
  questionCompose: 'Question - invites others to add voteable options for brainstorming',
  suggestCompose: 'Suggestion - others vote on this idea and then can be converted to a task',
  issueReview: 'Blocking issue',
  questionReview: 'Question',
  suggestReview: 'Suggestion',
  todoReview: 'Task',
  todoInfo: 'Info',
  reportNote: 'Note',
  intentDesignCapsule: 'Design',
  supersededIntentDesignCapsule: 'Superseded intent/design capsule',
  capsuleJobTarget: 'Job {target}',
  capsuleTaskTarget: 'Task {target}',
  issueSimple: 'issue',
  questionSimple: 'question',
  suggestSimple: 'suggestion',
  reportSimple: 'progress report',
  inProgress: 'In progress',
  inReview: 'In review',
  openAssistance: 'Open question or suggestion',
  markInProgress: 'Mark in progress',
  removeInProgress: 'Remove in progress',
  todoSimple: 'task',
  todoSimpleOption: 'info',
  reportsSectionLabel: 'Progress',
  todoPresent: 'Task',
  issueTip: 'Use to halt an option or job until resolved.',
  questionTip: 'Question',
  suggestTip: 'Suggestion',
  reportTip: 'Used to report status.',
  questionTitle: 'question',
  suggestTitle: 'suggestion',
  reportTitle: 'note',
  reportReviewTip: 'Report made after review of this job. Required reviewers must create.',
  todoTip: 'Use to insure this item is done in this job.',
  redTip: 'Alerts team with highest priority notification',
  blueTip: 'Does not send a notification but does highlight new',
  yellowTip: 'Alerts team with notification',
  notificationLabel: 'Bug',
  notificationLabelRED: 'Critical - persistently notify',
  notificationLabelYELLOW: 'Normal - notify once',
  notificationLabelBLUE: 'Minor - no notification',
  able: 'Normal',
  makeNormal: 'Move to normal',
  convenient: 'Minor',
  createNewQUESTION: 'Ask question',
  createNewISSUE: 'Add blocker',
  createNewTODO: 'Add task',
  createNewREPORT: 'Add note',
  createNewTODOOption: 'Add info',
  createNewTODOOptionExplanation: 'Add info to this option',
  createNewSUGGEST: 'Add suggestion',
  createNewISSUEExplanation: 'Add blocker to this option',
  createNewQUESTIONMobile: 'Question',
  createNewQUESTIONExplanation: 'Add question to this option',
  createNewISSUEMobile: 'Blocker',
  createNewTODOMobile: 'Task',
  createNewTODOOptionMobile: 'Info',
  createNewREPORTMobile: 'Note',
  createNewSUGGESTMobile: 'Suggestion',
  createNewSUGGESTExplanation: 'Add suggestion to this option',
  createNewStatus: 'Add progress report',
  createNewApproval: 'Add approval',
  createNewVote: 'Add vote',
  allDoneButton: 'All done',
  allDone: 'Move to Reviewable',
  allDoneClearNotifications: 'Move to Reviewable and clear its notifications',
  allDoneMoveOnly: 'Move to Reviewable only',
  inboxClearJob: "Clear all of this job's notifications",
  jobNavClearNotifications: 'Clear notifications',
  inboxMoveJobReviewable: 'Move job to Reviewable',
  inboxMoveJobReviewableClear: 'Move job to Reviewable and clear its notifications',
  addVoting: 'Add voting',
  createBug: 'Add bug',
  createComment: 'Add comment',
  createQuestion: 'Add question',
  createQuestionMobile: 'Question',
  createNote: 'Add note',
  createNoteMobile: 'Note', 
  createSuggestion: 'Add suggestion',
  createSuggestionMobile: 'Suggestion',
  createRedExplanation: 'Create a new bug with a notification that remains till resolved',
  createYellowExplanation: 'Create a new bug with a notification that can be dismissed',
  createBlueExplanation: 'Create a new bug without notification',
  taskSection: 'Tasks',
  openTasksSection: 'Open tasks',
  notesSection: 'Notes',
  notesResolvedMarker: 'Resolved.',
  openTodosTip: 'ctrl+alt+e Expand tasks',
  closeTodosTip: 'ctrl+shift+e Collapse tasks',
  openApprovalsTip: 'Expand approvals',
  closeApprovalsTip: 'Collapse approvals',
  openReportsTip: 'Expand reports',
  closeReportsTip: 'Collapse reports',
  closeDetailsTip: 'Collapse details',
  openDetailsTip: 'Expand details',
  tasksSection: 'Tasks',
  todoSection: 'Bugs',
  jobFromBugs: 'Bugs {ticketList}',
  switchTodoView: 'Switch view where bugs and jobs from code TODOs are created',
  isVisibleJobToolTip: 'Appears in the list that AI uses to find work',
  isVisibleCheckboxExplanation: 'Show AI',
  isAIAbleExplanation: 'AI able',
  addJobLabel: 'Add a job label',
  editJobLabel: 'Edit job label',
  labelPlaceholder: 'New Label',
  label: 'Label',
  readyToStartCheckboxExplanation: 'Ready to Assign',
  blockingIssueCheckboxExplanation: 'Not ready - issue',
  readyToStartDisplay: 'This job is ready for assignment',
  viewTodo: 'View',
  editTodo: 'Edit',
  markRead: 'Mark read',
  markDescriptionRead: 'Mark description read',
  markStoryRead: 'Mark job read',
  markReadMobile: 'Mark read',
  moveTodoRed: 'Move to critical bug',
  moveTodoYellow: 'Move to normal bug',
  moveTodoBlue: 'Move to minor bug',
  moveTodoResolved: 'Resolve this bug',
  resolvedBugsHeader: 'Resolved',
  resolvedToolTip: 'Resolved bugs are kept for reference. Drag back to a severity tab to unresolve.',
  moveNewJob: 'Move to new job',
  moveAssigned: 'Move to assigned',
  otherJob: 'Other job',
  moveOtherJob: 'Move to other job',
  startTodo: 'Start bug',
  startJob: 'Accept job',
  assignStartJob: 'Accept and skip voting',
  DecideMove: 'Reduce priority',
  DecideStartBug: 'Create job in Doable',
  DecideStartBugExisting: 'Find existing job',
  GotoBugs: 'Go to bugs',
  DecideAddReview: 'Reply to report',
  DecideAddTask: 'Add task',

  // Search
  searchBoxPlaceholder: 'Search',
  searchBoxPlaceholderMobile: ' Search',
  searchInfoTooltip: 'Finds recent items containing your text - browser storage limits how far back it reaches, and results display in a guided way. For complex searches, like "do we have a backlog job about X?", ask your AI agent - it searches the entire workspace.',
  previousInbox: 'ctrl+shift+arrowLeft Previous',
  nextInbox: 'ctrl+shift+arrowRight Next',
  NotificationResultJustify: 'Vote In:',
  MarketSearchResultWorkspace: 'Workspace',
  MarketSearchResultInitiative: 'Initiative',
  MarketSearchResultDialog: 'Dialog',
  InvestibleSearchResultStory: 'Job',
  InvestibleSearchResultOption: 'Option',
  uclusionAttachmentLinkCopied: 'In app attachment link copied',
  uclusionAttachmentLinkDirections: 'Click to copy in app attachment link',


  // existing users
  existingUsersBanUser: 'Remove collaborator',
  existingUsersUnBanUser: 'Readmit collaborator',
  banUserWarning: 'Removing a collaborator will prevent them from seeing any future updates',
  unbanUserWarning: 'Readmitting a collaborator will allow them to see any future updates',
  archiveMarketWarning: 'Archiving the workspace removes all notifications.',
  archiveWorkspace: 'Archive workspace',
  activateWorkspace: 'Activate workspace',

  // Notifications
  notificationDismiss: 'Dismiss',
  notificationDismissThread: 'Dismiss thread',
  blockedNotificationTitle: 'No actions available',
  blockedNotificationResolved: 'This notification has no actions because its comment was already resolved.',
  blockedNotificationGeneric: 'This notification has no actions, likely because the item it refers to changed after the notification was sent.',
  blockedNotificationViewComment: 'View resolved comment',

  //Hot keys
  hotKeyTODO: 'ctrl+a',
  hotKeyJob: 'ctrl+a A job holds tasks and other types.',
  hotKeyQUESTION: 'ctrl+q',
  hotKeyREPORT: 'ctrl+alt+n',
  hotKeySUGGEST: 'ctrl+alt+s',
  hotKeyISSUE: 'ctrl+alt+b',

  // phone field
  phoneFieldErrorText: 'Phone should begin with plus or just be the digits',

  // AddNewWizards
  WizardContinue: 'Next',
  wizardBreadCrumb: 'Compose',
  OnboardingInviteDialog: 'Almost ready to go! Loading fully complete momentarily.',
  OnboardingWizardTitle: 'Welcome to Uclusion',
  OnboardingWizardSkipOnboarding: 'I\'ve used Uclusion before and want to go right to the app',
  OnboardingWizardStartOver: 'Cancel',
  OnboardingWizardTrySomethingElse: 'I\'ve shared the link and want to try something else',
  OnboardingWizardGoBack: 'Go back',
  OnboardingWizardContinue: 'Next',
  OnboardingWizardFinish: 'Finish',
  OnboardingWizardAddOther: 'Send + other workspace',
  singlePersonView: 'Single person view',
  teamView: 'Certain people view',
  everyoneView: 'Everyone view',
  WorkspaceWizardCopyLink: 'Copy invite link',
  YesReady: 'Yes ready to assign',
  NoReady: 'No not ready',
  OnboardingWizardSkip: 'Skip this step',
  OnboardingWizardAdvancedOptionsStepLabel: 'Job short code',
  OnboardingWizardCurrentStoryNamePlaceHolder: 'Your current job\'s name',
  OnboardingWizardCurrentStoryDescriptionPlaceHolder: 'Your current job\'s description',
  OnboardingWizardNextStoryNamePlaceHolder: 'Your next job\'s name',
  OnboardingWizardNextStoryDescriptionPlaceHolder: 'Your next job\'s description',
  OnboardingWizardCurrentStoryProgressPlaceHolder: 'Your progress so far',

  // Workspace wizard
  WorkspaceWizardNameFieldLabel: 'Workspace name',
  WorkspaceWizardTitle: 'Your workspace',
  createWorkspaceNormal: 'Configure for team',
  createViewSingleUser: 'Configure for single',
  singleView: 'Single',
  configureLater: 'Configure later',

  // Job Wizard
  JobWizardGotoJob: 'Skip',
  JobWizardBacktoJob: 'Back to job',
  JobWizardBack: 'Back',
  JobWizardAssignJob: 'Assign job',
  JobWizardApproveJob: 'Approve job',
  DecisionWizardApprove: 'Approve option',
  JobWizardNewJob: 'New job',
  JobWizardExistingJob: 'Existing job',
  JobWizardStartOver: 'Start over',
  JobAssignNotDoing: 'Move to Skippable',
  JobAssignStart: 'Move to Doable',
  JobAssignBacklog: 'Move to Backlog',
  JobAssignWaiting: 'Move to Approvable',
  JobWizardReady: 'Backlog ready to assign',
  moveToReady: 'Move to ready to assign',
  moveToNotReady: 'Move to not ready',
  JobWizardNoAssign: 'Backlog not ready',
  skipAllApprovals: 'Skip all approvals',

  //GroupWizard
  GroupWizardMeetingName: 'Your view name',
  GroupWizardGotoGroup: 'Go to view',
  GroupWizardAddMembers: 'Add people',
  ApprovalRestrictNo: 'Assignees can approve their own jobs.',
  ApprovalRestrictYes: 'Assignees need approval from others.',
  createMyWorkView: 'My work view',
  createEveryoneView: 'Everyone view',
  groupTypeLabelAUTONOMOUS: 'My work',
  groupTypeLabelTEAM: 'Team',
  groupTypeLabelEVERYONE: 'Everyone',
  groupTypeTipAUTONOMOUS: 'A view with only you that displays your work across views',
  groupTypeTipTEAM: 'A view with you and selected collaborators',
  groupTypeTipEVERYONE: 'A view that automatically includes everyone in the workspace',

  // Decision comment wizard
  DecisionCommmentWizardTerminate: 'Back to option',
  InitiativeCommmentWizardTerminate: 'Back to suggestion',

  // Approve Wizard
  ApprovalWizardApprove: 'Approve job',
  ApprovalWizardAccept: 'Accept job',
  ApproveOwnAssignmentTitle: 'Approve assignment?',
  ApproveOwnAssignmentFullTitle: 'How certain are you of taking this assignment?',
  ApprovalWizardBlock: 'Block instead',
  WizardJobAssistance: 'Requires assistance',
  ISSUEApproveWizard: 'Create issue',
  QUESTIONApproveWizard: 'Create question',
  SUGGESTApproveWizard: 'Create suggestion',
  REPORTApproveWizard: 'Create report',
  NOTEApproveWizard: 'Create note',
  TODOApproveWizard: 'Create task',

  //Status Wizard
  StatusWizardEstimate: 'Estimate date',
  StatusWizardEstimateStart: 'Estimate and start',
  StatusWizardReport: 'Report progress',
  StatusWizardDate: 'Set date',
  StatusWizardDateStart: 'Set date and start',

  //Decide Wizard
  DecideWizardContinue: 'Continue to full display',
  DecideWizardMute: 'Mute this thread',
  DecideWizardApprove: 'Approve open option',
  DecideResolveAndGoJob: 'Resolve and go to job',
  DecideResolveAndMoveToJob: 'Resolve and move to job',
  DecideWizardReassign: 'Reassign',
  DecideJobOwner: 'Stop assignment',
  moveToTaskLabel: 'Move to task',
  moveReplyToTaskLabel: 'Move reply to task',
  RejectAssignment: 'Reject assignment',
  BugWizardMoveToBug: 'Move to bug',
  BugWizardMoveToJob: 'Move to job',

  //SignupWizard
  SignupWizardTitle: 'What do you want to create?',
  SignupWizardWelcome: 'Welcome to Uclusion!',
  SignupWizardQuestion: 'What do you want to do?',
  SignupWizardDialog: 'Dialog for brainstorming options outside your team.',
  SignupWizardInitiative: 'Initiative to measure support for a single option outside your team.',

  //AddOptionWizard
  AddOptionWizardTitle: 'Your Option',
  AddOptionWizardOptionNameStepLabel : 'Option Name',
  AddOptionWizardOptionDescriptionStepLabel: 'Option Description',
  AddOptionWizardOptionNamePlaceHolder: 'Your option\'s name',
  AddOptionWizardOptionDescriptionPlaceHolder: 'Your option\'s description',
  AddOptionWizardCancelOption: 'Cancel New Option',

  //ComposeWizard
  JOBComposeLabel: 'Job - holds assignments, tasks, questions, suggestions, blockers, and status',
  QUESTIONComposeLabel: 'Question - can have approvable options and movable to a job',
  SUGGESTComposeLabel: 'Suggestion - voted for or against and movable to a job as suggestion or task',
  TODOComposeLabel: 'Bug - movable to a job as a task',
  GROUPComposeLabel: 'View - for notification addressing and a separate status view',
  WORKSPACEComposeLabel: 'Workspace - everyone in a workspace can see all contents',
  compose: 'Compose',


  //UnblockWizard
  DecideMoveToBacklog: 'Move job to backlog',

  // StepHeaders
  StepHeadersStepCount: 'Step {currentStep} of {totalSteps}',

  IdentityChangeAvatar: 'Change your avatar',
  changeAvatarPreferences: 'Gravatar',
  IdentityTermsOfUse: 'Terms of Use',

  VideoDialogTitle: 'Insert a Video',
  VideoDialogTitleAddButton: 'Insert',
  VideoDialogUrl: 'URL for Video',
  VideoDialogUrlPlaceholder: 'Video URL',
  VideoDialogExplanation: 'Please provide the URL of the video to insert. We integrate with YouTube, Loom, and Vimeo, and support links to most video format files.',

  LinkDialogTitle: 'Add a Link',
  LinkDialogExplanation: 'Please provide the URL of the link you want to add.',
  LinkDialogUrl: 'URL for Link',
  LinkDialogUrlPlaceHolder: 'Link URL',


});

export default messages;
